import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedTab:1,
    receiveVoucherListing: {
        isLoading: false,
        isDataLoaded: false,
        voucherListingData: [],
        isLoadingFailed: false,
        failedMessage: null
    },
    editVoucherData: {
        isEditing: false,
        isLoading: false,
        isDataLoaded: true,
        voucherData: null,
        selectedTransferExternalForRepairReceiveId: null,
        isLoadingFailed: false,
        failedMessage: null
    }
}

const externalTransferForRepairSlice = createSlice({
    name: "externalTransferForRepair",
    initialState,
    reducers: {
        externalTransferForRepairSetSelectedTab: (state,{payload}) => {
            state.selectedTab = payload;
            if(payload === 2){
                state.editVoucherData = {...initialState.editVoucherData};
            }
        },
        externalTransferForRepairReceiveLoadingPending: (state) => {
            state.receiveVoucherListing.isLoading = true;
            state.receiveVoucherListing.isDataLoaded = false;
        },
        externalTransferForRepairReceiveLoadingSuccess: (state, { payload }) => {
            state.receiveVoucherListing.isLoading = false;
            state.receiveVoucherListing.voucherListingData = payload;
            state.receiveVoucherListing.failedMessage = "";
            state.receiveVoucherListing.isDataLoaded = true;
            state.receiveVoucherListing.isLoadingFailed = false;
        },
        externalTransferForRepairReceiveLoadingFailed: (state, { payload }) => {
            state.receiveVoucherListing.isLoading = false;
            state.receiveVoucherListing.voucherListingData = [];
            state.receiveVoucherListing.failedMessage = payload;
            state.receiveVoucherListing.isDataLoaded = true;
            state.receiveVoucherListing.isLoadingFailed = true;
        },
        // Edit Receive Voucher Reducers
        externalTransferForRepairReceiveSetFormEdit: (state,{payload}) => {
            state.editVoucherData.isEditing = true;
            state.editVoucherData.selectedTransferExternalForRepairReceiveId = payload;
        },
        externalTransferForRepairReceiveFormDataLoadingPending: (state) => {
            state.editVoucherData.isLoading = true;
            state.editVoucherData.isDataLoaded = false;
        },
        externalTransferForRepairReceiveFormDataLoadingSuccess: (state, { payload }) => {
            state.editVoucherData.isLoading = false;
            state.editVoucherData.voucherData = payload;
            state.editVoucherData.failedMessage = "";
            state.editVoucherData.isDataLoaded = true;
            state.editVoucherData.isLoadingFailed = false;
        },
        externalTransferForRepairReceiveFormDataLoadingFailed: (state, { payload }) => {
            state.editVoucherData.isLoading = false;
            state.editVoucherData.voucherData = null;
            state.editVoucherData.failedMessage = payload;
            state.editVoucherData.isDataLoaded = true;
            state.editVoucherData.isLoadingFailed = true;
        },
        externalTransferForRepairReceiveFormDataReset: (state, { payload }) => {
            state.editVoucherData.isEditing = false;
            state.editVoucherData.isLoading = false;
            state.editVoucherData.voucherData = null;
            state.editVoucherData.failedMessage = null;
            state.editVoucherData.isDataLoaded = false;
            state.editVoucherData.isLoadingFailed = false;
            state.editVoucherData.selectedTransferExternalForRepairReceiveId = null;
        },
        externalTransferForRepairReceiveReset: (state) => initialState
    }
});

const { reducer, actions } = externalTransferForRepairSlice;

export const {
    externalTransferForRepairSetSelectedTab,
    externalTransferForRepairReceiveLoadingPending, 
    externalTransferForRepairReceiveLoadingSuccess,
    externalTransferForRepairReceiveLoadingFailed,
    externalTransferForRepairReceiveSetFormEdit,
    externalTransferForRepairReceiveFormDataLoadingPending,
    externalTransferForRepairReceiveFormDataLoadingSuccess,
    externalTransferForRepairReceiveFormDataLoadingFailed,
    externalTransferForRepairReceiveFormDataReset,
    externalTransferForRepairReceiveReset
} = actions;

export default reducer;